import script from "./SA.vue?vue&type=script&setup=true&lang=js"
export * from "./SA.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__